import { LoginData } from '../../../../core/models/login-data';
import { LoginService } from './../../../../core/services/login.service';
import { DentalSupplierAddresses } from './../../models/dental-supplier-addresses';
import { ToastService } from './../../../../core/toast.service';
import { AddDentalSupplierAddressesService } from './../../services/add-dental-supplier-addresses.service';
import { FormBuilder, Validators } from '@angular/forms';
import { Component, ElementRef, Inject, NgZone, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UpdateDentalSupplierAddressesService } from '../../services/update-dental-supplier-addresses.service';
import { CheckPincodeService } from '../../services/check-pincode.service';
import { MapsAPILoader } from '@agm/core';
@Component({
  selector: 'app-add-address',
  templateUrl: './add-address.component.html',
  styleUrls: ['./add-address.component.scss']
})
export class AddAddressComponent implements OnInit, AfterViewInit {
  zoom: number;
  loginData: LoginData;
  addressForm = this.fb.group({
    id: [null, []],
    type: ['Home', [Validators.required]],
    other_type_name: [null, []],
    short_name: [null, [Validators.required]],
    line_1: [null, [Validators.required]],
    line_2: [null, []],
    landmark: [null, []],
    city: [null, [Validators.required]],
    state: [null, [Validators.required]],
    country: ['Australia', [Validators.required]],
    postal_code: [null, [Validators.required]],
    latitude: [0, [Validators.required]],
    longitude: [0, [Validators.required]],
    google_place_id: ["PLACE_ID123"],
    make_default: [true],
  });
  geoCoder: any;
  @ViewChild('search', { static: true })
  public searchElementRef: ElementRef;
  constructor(
    private _dialogRef: MatDialogRef<AddAddressComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DentalSupplierAddresses,
    private fb: FormBuilder,
    private addDentalSupplierAddressesService: AddDentalSupplierAddressesService,
    private updateDentalSupplierAddressesService: UpdateDentalSupplierAddressesService,
    private toast: ToastService,
    private loginService: LoginService,
    private checkPincodeService: CheckPincodeService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
  ) { }
  ngOnInit(): void {
    if (this.data) {
      console.log(this.data);
      this.addressForm.patchValue(this.data);
    }
    this.loginData = this.loginService.getLoginData();
    //load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      this.setCurrentLocation();
      this.geoCoder = new google.maps.Geocoder();
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: ["address"],
        componentRestrictions: {
          country: "AU"
        }
      });
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();
          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
          console.log(place);
          if (place.address_components.find(single => single.types.includes('locality')).long_name) {
            this.landmark.setValue(place.address_components.find(single => single.types.includes('locality')).long_name)
          } else {
            this.landmark.setValue(null)
          }
          if (place.address_components.find(single => single.types.includes('administrative_area_level_2')).long_name) {
            this.city.setValue(place.address_components.find(single => single.types.includes('administrative_area_level_2')).long_name)
          } else {
            this.city.setValue(null);
          }
          if (place.address_components.find(single => single.types.includes('administrative_area_level_1')).long_name) {
            this.state.setValue(place.address_components.find(single => single.types.includes('administrative_area_level_1')).long_name)
          } else {
            this.state.setValue(null);
          }
          if (place.address_components.find(single => single.types.includes('country')).long_name) {
            this.country.setValue(place.address_components.find(single => single.types.includes('country')).long_name)
          } else {
            this.country.setValue(null);
          }
          if (place.address_components.find(single => single.types.includes('postal_code')).long_name) {
            const pincode = place.address_components.find(single => single.types.includes('postal_code')).long_name;
            this.postal_code.setValue(pincode);
          } else {
            this.postal_code.setValue(null);
          }
          this.google_place_id.setValue(place.place_id);
          // this.addressLine1.setValue(place.formatted_address);
          //set latitude, longitude and zoom
          this.latitude.setValue(place.geometry.location.lat());
          this.longitude.setValue(place.geometry.location.lng());
          this.zoom = 12;
        });
      });
    });
  }
  ngAfterViewInit(): void {
  }
  dialogClose(status: string) {
    // this._dialogRef.close(status);
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this._dialogRef.close(status); }, 1000);
  }
  get idValue() {
    return this.id.value;
  }
  get id() {
    return this.addressForm.get('id');
  }
  get type() {
    return this.addressForm.get('type');
  }
  get other_type_name() {
    return this.addressForm.get('other_type_name');
  }
  get short_name() {
    return this.addressForm.get('short_name');
  }
  get line_1() {
    return this.addressForm.get('line_1');
  }
  get line_2() {
    return this.addressForm.get('line_2')
  }
  get landmark() {
    return this.addressForm.get('landmark')
  }
  get city() {
    return this.addressForm.get('city');
  }
  get state() {
    return this.addressForm.get('state')
  }
  get country() {
    return this.addressForm.get('country');
  }
  get postal_code() {
    return this.addressForm.get('postal_code');
  }
  get latitude() {
    return this.addressForm.get('latitude');
  }
  get longitude() {
    return this.addressForm.get('longitude');
  }
  get google_place_id() {
    return this.addressForm.get('google_place_id');
  }
  get make_default() {
    return this.addressForm.get('make_default');
  }
  async addUpdateAddress() {
    if (this.addressForm.invalid) {
      this.toast.openSnackBar('Please enter valid details');
      this.addressForm.markAllAsTouched();
      return;
    }
    let pincodeCount = await this.checkPincodeService.checkPincode(this.postal_code.value);
    console.log(pincodeCount);
    if (pincodeCount <= 0) {
      this.toast.openSnackBar('We are not serving to this area');
      return;
    }
    try {
      const address = this.addressForm.value as DentalSupplierAddresses;
      if (this.loginData.type === 'SUPPLIER') {
        if (this.idValue) {
          const response = await this.updateDentalSupplierAddressesService.updateDentalSupplierAddressesByPk(this.idValue, address);
          this.toast.openSnackBar('Address updated successfully');
        } else {
          const response = await this.addDentalSupplierAddressesService.addDentalSupplierAddresses(address);
          this.toast.openSnackBar('Address added successfully');
        }
      }
      if (this.loginData.type === 'PROFESSIONAL') {
        if (this.idValue) {
          const response = await this.updateDentalSupplierAddressesService.updateDentalProfessionalAddressesByPk(this.idValue, address);
          this.toast.openSnackBar('Address updated successfully');
        } else {
          const response = await this.addDentalSupplierAddressesService.addDentalProfessionalAddresses(address);
          this.toast.openSnackBar('Address added successfully');
        }
      }
      if (this.loginData.type === 'PRACTICE') {
        if (this.idValue) {
          const response = await this.updateDentalSupplierAddressesService.updateDentalPracticeAddressesByPk(this.idValue, address);
          this.toast.openSnackBar('Address updated successfully');
        } else {
          const response = await this.addDentalSupplierAddressesService.addDentalPracticeAddresses(address);
          this.toast.openSnackBar('Address added successfully');
        }
      }
      this.dialogClose('yes');
    } catch (error) {
      this.toast.openSnackBar('Unable to save address');
    }
  }
  // Get Current Location Coordinates
  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude.setValue(position.coords.latitude);
        this.longitude.setValue(position.coords.longitude);
        this.zoom = 15;
      });
    }
  }
}
